import { useState } from 'react';
import { useQuery } from 'react-query';
import isItemPortCall from '@shared/utils/isItemPortCall';
import { getVoyageItinerary } from '@client/lib/api';
import { ItineraryPortCallDto } from '@client/screens/estimates/details/helpers/types';
import { usePortOptions } from './usePortOptions';

export const usePortCalls = (voyageId?: number) => {
	const [portCalls, setPortCalls] = useState<ItineraryPortCallDto[]>([]);

	useQuery(
		['itinerary', voyageId],
		() => getVoyageItinerary(voyageId!),
		{
			enabled: voyageId != null,
			onSuccess: (data) => {
				const filtered = data.filter((e) => isItemPortCall(e)) as ItineraryPortCallDto[];
				setPortCalls(filtered);
			},
		},
	);

	const portCallOptions = usePortOptions(portCalls);

	return {
		portCalls,
		portCallOptions,
	};
};
